import { render, staticRenderFns } from "./Alias.vue?vue&type=template&id=5d37e27a&scoped=true&"
import script from "./Alias.vue?vue&type=script&lang=ts&"
export * from "./Alias.vue?vue&type=script&lang=ts&"
import style0 from "./Alias.vue?vue&type=style&index=0&id=5d37e27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37e27a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d37e27a')) {
      api.createRecord('5d37e27a', component.options)
    } else {
      api.reload('5d37e27a', component.options)
    }
    module.hot.accept("./Alias.vue?vue&type=template&id=5d37e27a&scoped=true&", function () {
      api.rerender('5d37e27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Settings/Alias.vue"
export default component.exports